
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/gift-shop-parlor",
      function () {
        return require("private-next-pages/outlet/gift-shop-parlor.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/gift-shop-parlor"])
      });
    }
  